export class UPSConstant {
  static UPS: string = 'UPS';
  static UPSSignature: string = 'UPS Signature';
}